import { Component, ViewChild, ElementRef } from '@angular/core';
import { ViewController, Events, Platform, AlertController } from 'ionic-angular';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { File } from '@ionic-native/file';
import { Camera, CameraOptions } from '@ionic-native/camera';

@Component({
  selector: 'page-filepicker',
  templateUrl: 'filepicker.html'
})
export class FilePickerPopOver {
  @ViewChild('hiddenCamera') cameraInput: ElementRef;
  @ViewChild('hiddenDoc') docInput: ElementRef;

  constructor(public viewCtrl: ViewController,
              public events: Events,
              private filePicker: IOSFilePicker,
              private platform: Platform,
              private file: File,
              private camera: Camera,
              private alertCtrl: AlertController) {}

  ionViewDidEnter() {
    const hiddenCamera = this.cameraInput.nativeElement as HTMLInputElement;
    const hiddenDoc = this.docInput.nativeElement as HTMLInputElement;
    const reader = new FileReader();

    var htmlElementCamera =  <HTMLInputElement>document.getElementById('hiddenCamera');
    hiddenCamera.onchange = () => {
      reader.onload = (r: any) => {         
        this.events.publish('notices:filepicker',
          r.target.result as string,
          htmlElementCamera.files.item(0).name,
          htmlElementCamera.files.item(0).type
        );
      };
      reader.readAsDataURL(hiddenCamera.files[0]);
    };

    var htmlElementDoc =  <HTMLInputElement>document.getElementById('hiddenDoc');
    hiddenDoc.onchange = () => {
      reader.onload = (r: any) => {       
        this.events.publish('notices:filepicker',
          r.target.result as string,
          htmlElementDoc.files.item(0).name,
          htmlElementDoc.files.item(0).type
        );
      };
      reader.readAsDataURL(hiddenDoc.files[0]);
    };

    /* Auskommentiert wegen BUGFIX: SP-747 Lukas
    this.events.subscribe('filepickerpopover:close', () => {
      this.close();
    }); */
  }

  pick(type:string){
    if(type == "camera") {
      if(this.platform.is('ios')) {
        this.takePictureAndConvert();
      } else {
        document.getElementById('hiddenCamera').click();
      }
    } else if (type == "galerie") {
      if(this.platform.is('ios')) {
        this.pickPictureAndConvert();
      } else {
        document.getElementById('hiddenDoc').click();
      }
    } else {
      if(this.platform.is('ios')){
        this.pickFileAndConvert();
      } else {
        document.getElementById('hiddenDoc').click();
      }
    }
  }

  pickFileAndConvert() {
    this.filePicker.pickFile()
    .then(uri => {
      let correctPath = uri.substr(0, uri.lastIndexOf('/') + 1);
      let currentName = uri.substring(uri.lastIndexOf('/') + 1).replace(/\.[^/.]+$/, "");
      let currentType = uri.substring(uri.lastIndexOf('.') + 1);
      console.log("PATH: ", correctPath);
      console.log("NAME: ", currentName);

      this.file.readAsDataURL(correctPath, currentName).then(base64 => {
        this.returnBase64ToNotices(base64, currentName, currentType);
      })
      .catch(err => console.log('Error', err));
    })
    .catch(err => console.log('Error', err));
  }

  takePictureAndConvert() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.cameraGetFile(options);
  }

  pickPictureAndConvert() {
    const options: CameraOptions = {
      quality: 100,
      sourceType : this.camera.PictureSourceType.PHOTOLIBRARY,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.cameraGetFile(options);
  }

  cameraGetFile(options) {
    this.camera.getPicture(options).then(base64 => {
      let base64Image = 'data:image/jpeg;base64,' + base64;
      this.showAlertFilename(base64Image);
    }, (err) => {
      console.log(err);
    });
  }

  showAlertFilename(base64Image) {
    let alert = this.alertCtrl.create({
      title: 'Filename',
      inputs: [{
          name: 'filename',
          placeholder: 'Filename ...'
        }],
      buttons: [{
          text: 'Speichern',
          handler: data => {
            this.returnBase64ToNotices(base64Image, data.filename.replace(/\.[^/.]+$/, "") + ".jpeg", "jpeg")
          }
        }
      ]
    });
    alert.present();
  }

  returnBase64ToNotices(base64, name, type) {
    this.events.publish('notices:filepicker',
      base64,
      name,
      type
    );
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/popovers/filepicker/filepicker.ts